import {
	all,
	takeEvery,
	put,
	fork,
	call,
	actionChannel,
} from "redux-saga/effects";
import { saveCampaign, saveCampaignTemplateType, saveWhatsappNumbers } from "../actions/Campaign";
import {
	SHOW_LOADING,
	GET_CAMPAIGN,
	LOAD_CAMPAIGN,
	UPDATE_CAMPAIGN,
	CREATE_CAMPAIGN,
	GET_CAMPAIGN_TEMPLATE_TYPES,
	GET_WHATSAPP_NUMBERS,
} from "../constants/Campaign";
import ApiService from "../../Services/ApiService";
import { toastNotification } from "../../utils/toastNotification";

function* getCampaigns() {
	yield takeEvery(GET_CAMPAIGN, function* (action) {
		let url = "/hulk/api/v1/campaigns";
		if (typeof action.payload == "string") {
			url = url + "?" + action.payload;
			action.payload = null;
		}
		try {
			const res = yield ApiService.get(url, {}, action.payload);
			console.log("getCampaigns()", res);
			yield put(saveCampaign(res.data));
		} catch (err) {
			//   yield put(authStatus(false));
			console.log(err);
		}
	});
}
function* getCampaignTemplateTypes() {
	yield takeEvery(GET_CAMPAIGN_TEMPLATE_TYPES, function* () {
		try {
			const res = yield ApiService.get(
				"/hulk/api/v1/whatsapp-templates/yes"
			);
			console.log("getCampaignTemplateTypes()", res);
			yield put(saveCampaignTemplateType(res.data));
		} catch (err) {
			//   yield put(authStatus(false));
			console.log(err);
		}
	});
}
function* updateCampaign() {
	yield takeEvery(UPDATE_CAMPAIGN, function* (action) {
		try {
			const res = yield ApiService.put(
				`/hulk/api/v1/campaigns/${action.payload.data.id}`,
				{},
				action.payload.data
			);
			toastNotification({ res })
			yield put({ type: GET_CAMPAIGN, payload: action.payload.query });
		} catch (err) {
			toastNotification({ errorMessage: "Internal Server Error" });
			console.log(err);
		}
	});
}

function* createCampaign() {
	console.log("SAGA CALLED");
	yield takeEvery(CREATE_CAMPAIGN, function* (action) {
		console.log("YAHAN");
		try {
			console.log("API SENDING");
			const res = yield ApiService.post(
				`/hulk/api/v1/campaigns`,
				{},
				action.payload.data
			);
			console.log("API RESPONSE");
			toastNotification({ res })
			console.log('payload ===>', action.payload)
			yield put({ type: GET_CAMPAIGN, payload: action.payload.query });
		} catch (err) {
			toastNotification({ errorMessage: "Internal Server Error" });
			console.log(err);
		}
	});
}

function* getWhatsappNumbers() {
	yield takeEvery(GET_WHATSAPP_NUMBERS, function* (action) {
		try {
			const res = yield ApiService.get("/hulk/api/v1/whatsapp-numbers-campaign");

			if (res && res.status == "success") {
				yield put(saveWhatsappNumbers(res.data));
			}
		} catch (err) {
			toastNotification({ errorMessage: "Internal Server Error" });
			console.log(err);
		}
	});
}
export default function* rootSaga() {
	yield all([
		getCampaigns(),
		updateCampaign(),
		getCampaignTemplateTypes(),
		createCampaign(),
		getWhatsappNumbers()
	]);
}
